import React, { useEffect, useState } from 'react';
import moment from 'moment';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import { Typography } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';

import { IOrder, IOrderState } from '../types/strapi';

const useStyles = makeStyles((theme) => ({
  title: {
    margin: 0,
    padding: theme.spacing(2),
    color: theme.palette.primary.main,
    display: 'flex',
    alignItems: 'center',
  },
  closeButton: {
    position: 'relative',
    color: theme.palette.grey[500],
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
  },
  description: {
    color: theme.palette.primary.main,
  },
}));

interface OrderStateModalProps {
  order: IOrder | null;
  onUpdate: (state: IOrderState) => void;
  onCancel: () => void;
}

const OrderStateModal: React.FC<OrderStateModalProps> = ({ order, onUpdate, onCancel }) => {
  const classes = useStyles();
  const [orderStateModalOpen, setOrderStateModalOpen] = useState(false);
  const [state, setState] = useState<IOrderState>(IOrderState.new);

  useEffect(() => {
    setOrderStateModalOpen(!!order);
    if (order) {
      setState(order.state);
    }
  }, [order]);

  const handleClose = () => {
    setOrderStateModalOpen(false);
    onCancel();
  };

  const handleConfirm = () => {
    setOrderStateModalOpen(false);
    onUpdate(state);
  };

  return (
    <Dialog open={orderStateModalOpen} onClose={handleClose}>
      <DialogTitle disableTypography className={classes.title}>
        <Typography variant="h6">Aggiorna ordine</Typography>
        <IconButton aria-label="close" className={classes.closeButton} onClick={() => handleClose()}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent className={classes.content}>
        <Typography variant="subtitle1" gutterBottom className={classes.description}>
          {`${moment(order?.date).format('DD/MM/YYYY')} - ${order?.name} ${order?.surname}`}
        </Typography>
        <FormControl>
          <InputLabel>Stato ordine</InputLabel>
          <Select value={state} onChange={(event) => setState(event.target.value as IOrderState)}>
            <MenuItem value={IOrderState.new}>Nuovo</MenuItem>
            <MenuItem value={IOrderState.delivering}>In consegna</MenuItem>
            <MenuItem value={IOrderState.completed}>Completato</MenuItem>
          </Select>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={handleClose}>
          Annulla
        </Button>
        <Button autoFocus onClick={handleConfirm} color="primary">
          Aggiorna
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default OrderStateModal;
